export const SOCIAL_SHARE_URL = 'https://covid19.pulkits.dev';
export const SOCIAL_SHARE_TEXT = 'Track confirmed cases of COVID-19 around the globe.'